import { useEffect, useState } from 'react'
import { CRED_STATUS_LABELS, CRED_STATUSES } from '../../../shared/projects.js'
import styles from './projects.module.css'

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

/** 2026-10-28 → "28 Oct" */
export function fmtDate(iso) {
  if (!iso) return '–'
  const [, m, d] = iso.split('-')
  return `${Number(d)} ${MONTHS[Number(m) - 1]}`
}

export function fmtDateYear(iso) {
  return iso ? `${fmtDate(iso)} ${iso.slice(0, 4)}` : '–'
}

/** Text or date input that saves when you leave the field, and only if the value changed. */
export function CommitInput({ value, onCommit, className = styles.input, ...rest }) {
  const [draft, setDraft] = useState(value ?? '')
  useEffect(() => setDraft(value ?? ''), [value])
  return (
    <input
      {...rest}
      className={className}
      value={draft}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={() => draft !== (value ?? '') && onCommit(draft)}
      onKeyDown={(e) => e.key === 'Enter' && e.currentTarget.blur()}
    />
  )
}

export function CommitText({ value, onCommit, ...rest }) {
  const [draft, setDraft] = useState(value ?? '')
  useEffect(() => setDraft(value ?? ''), [value])
  return (
    <textarea
      {...rest}
      className={styles.textarea}
      value={draft}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={() => draft !== (value ?? '') && onCommit(draft)}
    />
  )
}

export const STATUS_PILL = {
  none: styles.pNone,
  requested: styles.pReq,
  received: styles.pRec,
  verified: styles.pOk,
  blocked: styles.pBad,
}

export function CredStatusSelect({ value, onChange, disabled, label }) {
  return (
    <select
      className={`${styles.statusSelect} ${STATUS_PILL[value]}`}
      value={value}
      disabled={disabled}
      aria-label={label}
      onChange={(e) => onChange(e.target.value)}
    >
      {CRED_STATUSES.map((s) => (
        <option key={s} value={s}>
          {CRED_STATUS_LABELS[s]}
        </option>
      ))}
    </select>
  )
}

const PROJECT_PILL = { discovery: styles.pNone, build: styles.pRec, uat: styles.pReq, live: styles.pOk, on_hold: styles.pBad }
export const projectPill = (status) => `${styles.pill} ${PROJECT_PILL[status]}`
